import styled from 'styled-components';
import { ReactComponent as ArrowButtonIcon } from '../../images/arrow-right.svg';
import { WHITE, UI_COLORS } from '../../utils/colors';
import { ZINDEX } from '../../utils/constants';

export const Button = styled.button`
  background: ${WHITE};
  border: none;
  outline: none;
  height: 48px;
  width: 48px;
  z-index: ${ZINDEX.TABLE_OF_CONTENTS - 1};
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.05), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  color: ${UI_COLORS[2]};
  font-size: 10.4px;
  font-weight: bold;
  border-radius: 50%;
  position: fixed;
  left: 24px;
  bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

export const ArrowIcon = styled(ArrowButtonIcon)`
  width: 13px;
  height: 11px;
  transform: rotate(270deg);

  path {
    fill: ${UI_COLORS[2]};
    stroke: ${UI_COLORS[2]};
    stroke-width: 2;
  }
`;
